import React from 'react';
import PropTypes from 'prop-types';
import 'reset-css/reset.css';
import '../color/color';
import Table from './table';
import css from './table-collapse.css';

const TableCollapse = ({ children }) => (
  <div className={css['ds-table-collapse']}>
    <Table>{children}</Table>
  </div>
);

TableCollapse.defaultProps = {
  children: null,
};

TableCollapse.propTypes = {
  children: PropTypes.node,
};

export default TableCollapse;
